"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    decodeJwt: ()=>decodeJwt,
    parseJwt: ()=>parseJwt,
    parseJwtLegacy: ()=>parseJwtLegacy
});
function parseJwt(token) {
    try {
        const payload = token.split('.')[1];
        return JSON.parse(utf8Decoder.decode(decodeBase64Url(payload)));
    } catch (error) {
        console.error('[ParseJwt] jwt parse error', error);
        return null;
    }
}
const decodeJwt = parseJwt;
const utf8Decoder = new TextDecoder();
function decodeBase64(str) {
    const binary = atob(str);
    const bytes = new Uint8Array(new ArrayBuffer(binary.length));
    const half = binary.length / 2;
    for(let i = 0, j = binary.length - 1; i <= half; i++, j--){
        bytes[i] = binary.charCodeAt(i);
        bytes[j] = binary.charCodeAt(j);
    }
    return bytes;
}
function decodeBase64Url(str) {
    return decodeBase64(str.replace(/_|-/g, (m)=>{
        var _m;
        return null != (_m = ({
            _: '/',
            '-': '+'
        })[m]) ? _m : m;
    }));
}
const parseJwtLegacy = (token)=>{
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url && base64Url.replace(/-/g, '+').replace(/_/g, '/');
        if (base64) return JSON.parse(decodeURIComponent(escape(atob(base64))));
        return null;
    } catch (err) {
        console.error('[JWT] jwt parse error', err);
        return null;
    }
};
exports.decodeJwt = __webpack_exports__.decodeJwt;
exports.parseJwt = __webpack_exports__.parseJwt;
exports.parseJwtLegacy = __webpack_exports__.parseJwtLegacy;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "decodeJwt",
    "parseJwt",
    "parseJwtLegacy"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
